import { render, staticRenderFns } from "./ProductType.vue?vue&type=template&id=281864c4&scoped=true&"
import script from "./ProductType.vue?vue&type=script&lang=js&"
export * from "./ProductType.vue?vue&type=script&lang=js&"
import style0 from "./ProductType.vue?vue&type=style&index=0&id=281864c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281864c4",
  null
  
)

export default component.exports